import CloseIcon from '@mui/icons-material/Close';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Stack, Typography } from '@mui/material';

import { Button } from '@/components/ui/button.tsx';

import { MutationButton } from '../../components/general/MutationButton.tsx';
import { content } from './VorschlaegeVerwerfenDialog.content';

type DiscardAllVorschlaegeDialogProps = {
  readonly open?: boolean;
  readonly loading?: boolean;
  readonly onApprove: () => void | Promise<void>;
  readonly onClose: () => void;
};

export const DiscardAllVorschlaegeDialog = ({
  open = false,
  loading = false,
  onApprove,
  onClose,
}: DiscardAllVorschlaegeDialogProps) => (
  <Dialog
    open={open}
    onClose={loading ? undefined : onClose}
    disableEscapeKeyDown={loading}
    maxWidth={false}
    slotProps={{
      paper: {
        sx: {
          width: 480,
          m: 2,
          p: 3,
          borderRadius: 2,
        },
      },
    }}
  >
    <DialogTitle sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5, p: 0, mb: 2 }}>
      <ErrorOutlineIcon sx={{ color: 'warning.main', mt: 0.25, mb: 0.25 }} />
      <Typography variant="headingXs" component="span" sx={{ flex: 1 }}>
        {content.title}
      </Typography>
      <IconButton aria-label={content.closeDialogAriaLabel} size="small" disabled={loading} onClick={onClose}>
        <CloseIcon fontSize="small" />
      </IconButton>
    </DialogTitle>
    <DialogContent sx={{ px: 0, pt: 2, pb: 0 }}>
      <Stack spacing={1.5}>
        <Typography variant="paragraph">{content.mainText}</Typography>
        <Typography variant="paragraph">{content.hint}</Typography>
      </Stack>
    </DialogContent>
    <DialogActions sx={{ gap: 2, justifyContent: 'flex-end', px: 0, pt: 4, pb: 0 }}>
      <Button label={content.cancelButton} variant="tertiary" size="compact" disabled={loading} onClick={onClose} />
      <MutationButton
        label={content.approveButton}
        variant="primary"
        size="compact"
        disabled={loading}
        loading={loading}
        onClick={() => void onApprove()}
      />
    </DialogActions>
  </Dialog>
);
